import { string } from 'yup';

const rule = {
	name: 'maxlengthExcludingSpaces',
	method ({ message } = { message: 'Please enter no more than 16 characters.' }) {

		return this.test('maxlengthExcludingSpaces', message, function (value) {

			const { createError } = this;
			return value.replace(/[\s-]/g, '').length <= 16 || createError({ message });

		});

	},
	schemaType: string
};

export default rule;
